import { render } from "./Tippy.vue?vue&type=template&id=648db0b0"
import script from "./Tippy.vue?vue&type=script&lang=js"
export * from "./Tippy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__